import StatusTag from "./StatusTag.tsx";

type Props = {
  title?: string;
  subTitle?: string;
  statusText?: string;
};
const Title = ({ title, subTitle, statusText }: Props) => {
  return (
    <>
      <StatusTag disposedText={statusText} />
      {/* WebKit's aggressive phone number detection changes text into a link
      so adding s-text! no-underline! should prevent it if the title contains a set of numbers */}
      {title && <h1 className="t1 mb-0 break-words s-text! no-underline!">{title}</h1>}
      {subTitle && <p className="s-text-subtle mb-0 mt-8 break-words">{subTitle}</p>}
    </>
  );
};

export default Title;
